export const useTranslation = () => ({
  ru: {
    rank: 'Ранг',
    rarity: 'Редкость',
    attributes: 'Атрибуты',
    items: 'штук',
    inCollection: 'в коллекции',
    noAttributes: 'Без атрибутов',
    noAttributesTitle: 'NFT без атрибутов',
    noAttributesDescription: 'Этот NFT не имеет атрибутов',
    rankAmong: "ранг среди",
    rankAmongDead: "ранг среди мертвых котов",
    rankAmongAlive: "ранг среди живых котов",
    unique: 'Уникальный'
  },
  en: {
    rank: 'Rank',
    rarity: 'Rarity',
    attributes: 'Attributes',
    items: 'items',
    inCollection: 'in collection',
    noAttributes: 'No Attributes',
    noAttributesTitle: 'NFT without attributes',
    noAttributesDescription: 'This NFT has no attributes',
    rankAmong: "rank among",
    rankAmongDead: "rank among dead cats",
    rankAmongAlive: "rank among alive cats",
    unique: 'Unique'
  }
}); 